import React, { useEffect, useState } from "react";
import API from "../api/api";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
import { Modal, Button } from "react-bootstrap";
import AppShell from "../components/ui/AppShell";
import PageHeader from "../components/ui/PageHeader";
import StatusBadge from "../components/ui/StatusBadge";
import EmptyState from "../components/ui/EmptyState";

const BookingStatusPage = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [currentTab, setCurrentTab] = useState("assign");
  const [showView, setShowView] = useState(false);
  const [viewBooking, setViewBooking] = useState({});

  const fetchBookings = async () => {
    try {
      const res = await API.get("/assisted-bookings");
      setBookings(res.data);
      setLoading(false);
    } catch (err) {
      setError("Failed to fetch bookings");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBookings();
  }, []);

  const filteredBookings = bookings.filter((b) => b.status === currentTab);

  const copyAllFields = (booking) => {
    const text = Object.entries(booking)
      .map(([key, val]) => `${key}: ${val || "-"}`)
      .join("\n");
    navigator.clipboard.writeText(text);
    alert("All fields copied!");
  };

  return (
    <AppShell>
      <PageHeader
        title="Booking Status"
        description="Filter assisted bookings by assignment state."
      />

      <div className="page-header-actions mb-3" style={{ justifyContent: "flex-start" }}>
        <Button
          variant={currentTab === "assign" ? "primary" : "outline-primary"}
          onClick={() => setCurrentTab("assign")}
        >
          Assign
        </Button>
        <Button
          variant={currentTab === "booked" ? "primary" : "outline-primary"}
          onClick={() => setCurrentTab("booked")}
        >
          Booked
        </Button>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      {loading ? (
        <div className="vp-loading">Loading bookings…</div>
      ) : filteredBookings.length === 0 ? (
        <EmptyState
          title="No bookings found"
          description={`There are no bookings in the “${currentTab}” state.`}
        />
      ) : (
        <div className="vp-table-wrap table-responsive">
          <table className="table table-hover mb-0">
            <thead>
              <tr>
                <th>#</th>
                <th>Service</th>
                <th>Name</th>
                <th>Passport</th>
                <th>Contact</th>
                <th>Assigned User</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredBookings.map((b, i) => (
                <tr key={b.id}>
                  <td>{i + 1}</td>
                  <td>{b.service_type}</td>
                  <td>
                    {b.first_name} {b.last_name}
                  </td>
                  <td>{b.passport_number}</td>
                  <td>{b.contact_number}</td>
                  <td>{b.assigned_user_name || "-"}</td>
                  <td>
                    <StatusBadge tone={b.status === "booked" ? "success" : "info"}>
                      {b.status}
                    </StatusBadge>
                  </td>
                  <td>
                    <div className="vp-table-actions">
                      <Button
                        size="sm"
                        variant="outline-primary"
                        title="View"
                        onClick={() => {
                          setViewBooking(b);
                          setShowView(true);
                        }}
                      >
                        <FaEye />
                      </Button>
                      <Button
                        size="sm"
                        variant="warning"
                        onClick={() => alert("Edit functionality")}
                      >
                        <FaEdit />
                      </Button>
                      <Button
                        size="sm"
                        variant="danger"
                        onClick={() => alert("Delete functionality")}
                      >
                        <FaTrash />
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <Modal show={showView} onHide={() => setShowView(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>View Booking</Modal.Title>
          <Button
            variant="secondary"
            className="ms-auto"
            onClick={() => copyAllFields(viewBooking)}
          >
            Copy All
          </Button>
        </Modal.Header>
        <Modal.Body>
          {Object.entries(viewBooking).map(([key, val]) => (
            <p key={key}>
              <strong>{key}:</strong> {val || "-"}
            </p>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowView(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </AppShell>
  );
};

export default BookingStatusPage;
